import { GridHorizontal } from '@styled-icons/boxicons-regular';
import { DreamBlock } from '@typedream/core';
import { findNodePath, focusEditor, toDOMNode } from '@udecode/plate-core';
import { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { useTPlateEditorRef } from '../../../plate';
import { selectElement } from '../../elementSelection/transforms';
import styles from './DragHandle.module.css';

interface DragHandleProps {
  element: DreamBlock
}

export function DragHandle(props: DragHandleProps) {
  const editor = useTPlateEditorRef();
  const { element } = props;

  const [, dragSource, dragPreview] = useDrag(
    () => ({
      type: 'block',
      item: () => {
        editor.isDragging = true;
        return { id: element.id };
      },
      end: () => {
        delete editor.isDragging;
      },
    }),
    [element],
  );

  useEffect(() => {
    try {
      const domElement = toDOMNode(editor, element);
      if (domElement) {
        const rect = domElement.getBoundingClientRect();
        dragPreview(domElement, {
          offsetX: rect.width / 2,
          offsetY: rect.height / 2,
        });
      }
    } catch (error) {
      console.error(error);
    }
  });

  return (
    <div
      role="none"
      ref={dragSource}
      className={styles.grabber}
      onMouseUp={(event) => {
        // handle here because plugin onMouseUp handler will not get correct target
        event.stopPropagation();
        const path = findNodePath(editor, element);
        if (path) {
          selectElement(editor, path, !!event.metaKey);
          focusEditor(editor);
        }
      }}
    >
      <GridHorizontal
        size={20}
      />
    </div>
  );
}
